import { useEffect, useRef, useState } from 'react';
import { throttle } from 'utils/common';

export const useTableHook = () => {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const [showBoxShadow, setShowBoxShadow] = useState({ vertical: false, horizontal: false });

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = throttle(() => {
      if (tableContainer) {
        setShowBoxShadow({
          vertical: tableContainer.scrollWidth > tableContainer.clientWidth,
          horizontal: tableContainer.scrollHeight > tableContainer.clientHeight,
        });
      }
    }, 100);

    window?.addEventListener('resize', handleScroll);
    handleScroll();

    return () => {
      window?.removeEventListener('resize', handleScroll);
    };
  }, []);

  return { tableContainerRef, showBoxShadow };
};
